const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/553436710349"
      className="fixed bottom-5 right-5 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 group"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Fale conosco no WhatsApp"
    >
      <i className="fab fa-whatsapp text-2xl animate-pulse group-hover:animate-none" />
    </a>
  );
};

export default WhatsAppButton;